<template>
  <div style="height: 100%">
    <el-container>
      <el-header v-show="!$route.meta.showNavMenu"><Header /></el-header>
      <el-container class="main">
        <!-- <el-aside width="200px">Aside</el-aside> -->
        <el-main><router-view /></el-main>
      </el-container>
      <el-footer><Footer /></el-footer>
    </el-container>
  </div>
</template>

<script>
import Header from './Header.vue';
import Footer from './Footer';
export default {
  name: 'Index',
  components: { Header, Footer },
  props: {
    msg: String,
  },
};
</script>
<style lang="scss">
body,
html {
  height: 100%;
  background-color: #33353e !important;
}
.el-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  border-image: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0 !important;
}
.el-header,
.el-footer {
  background-color: #33353e;
  color: #ffffff;
  text-align: center;
  width: 100%;
  text-align: center;
  margin: 0 auto;
  padding: 0 !important;
}

.el-main {
  background-color: #33353e;
  color: #d1d4dc;
  height: 100% !important;
  padding: 0 !important;
  //display: flex;
  //justify-content: center !important;
}

// .el-main {
//   background-color: #33353e;
//   color: #d1d4dc;
//   height: 100% !important;
//   // width: 1200px;
//   // text-align: center;
//   // margin: 0 auto;
//   padding: 0 !important;
//   display: flex;
//   justify-content: center !important;
// }

body > .el-container {
  margin-bottom: 40px;
  height: 100%;
}
.el-container {
  // height: 100%;
  background-color: #33353e;
  // .main{
  //   width: 1200px;
  //   margin: 0 auto;
  //   text-align: center;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue